import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@filadd/phi-plus-styled-system/css";
import { isCssProperty, styled, } from "@filadd/phi-plus-styled-system/jsx";
import { createContext, forwardRef, useContext, } from "react";
const shouldForwardProp = (prop, variantKeys, options = {}) => {
    var _a;
    return ((_a = options.forwardProps) === null || _a === void 0 ? void 0 : _a.includes(prop)) ||
        (!variantKeys.includes(prop) && !isCssProperty(prop));
};
export const createStyleContext = (recipe) => {
    const StyleContext = createContext(null);
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    const withRootProvider = (Component) => {
        const StyledComponent = (props) => {
            const [variantProps, otherProps] = recipe.splitVariantProps(props);
            const slotStyles = recipe(variantProps);
            return (_jsx(StyleContext.Provider, { value: slotStyles, children: _jsx(Component, Object.assign({}, otherProps)) }));
        };
        return StyledComponent;
    };
    const withProvider = (Component, slot, options) => {
        const StyledComponent = styled(Component, {}, {
            shouldForwardProp: (prop, variantKeys) => shouldForwardProp(prop, variantKeys, options),
        });
        const StyledSlotProvider = forwardRef((props, ref) => {
            const [variantProps, otherProps] = recipe.splitVariantProps(props);
            const slotStyles = recipe(variantProps);
            return (_jsx(StyleContext.Provider, { value: slotStyles, children: _jsx(StyledComponent, Object.assign({}, otherProps, { ref: ref, className: cx(slotStyles === null || slotStyles === void 0 ? void 0 : slotStyles[slot], props.className) })) }));
        });
        StyledSlotProvider.displayName = Component.displayName || Component.name;
        return StyledSlotProvider;
    };
    const withContext = (Component, slot) => {
        const StyledComponent = styled(Component);
        const StyledSlotComponent = forwardRef((props, ref) => {
            const slotStyles = useContext(StyleContext);
            return (_jsx(StyledComponent, Object.assign({}, props, { ref: ref, className: cx(slotStyles === null || slotStyles === void 0 ? void 0 : slotStyles[slot], props.className) })));
        });
        StyledSlotComponent.displayName = Component.displayName || Component.name;
        return StyledSlotComponent;
    };
    return {
        withRootProvider,
        withProvider,
        withContext,
    };
};
//# sourceMappingURL=create-styled-context.js.map